import { css } from 'glamor'

export default {
  titleWrapper: css({
    minHeight: '90px',
    height: 'auto',
    display: 'flex',
    alignItems: 'center',
    justifyContent: 'center',

    '@media(min-width: 700px)': {
      minHeight: '0px',
      height: '130px',
    },
  }),
  title: css({
    fontSize: '18px',
    textAlign: 'center',
    lineHeight: '1.3',
    margin: '30px 0',

    '@media(min-width: 700px)': {
      margin: '0px',
    },
  }),
  imagesAndArrow: css({
    color: '#ed5d42',

    ':hover': {
      color: '#e63816',
    },
  }),
  images: css({
    display: 'flex',
    flexDirection: 'column',
    alignItems: 'center',
    justifyContent: 'space-between',

    '@media(min-width: 700px)': {
      flexDirection: 'row',
    },
  }),
  image: css({
    width: '310px',
    minHeight: '175px',

    ':hover': {
      opacity: '.8'
    },

    '&:first-child': {
      // borderBottom: '2px solid white',

      '@media(min-width: 700px)': {
        // marginBottom: '15px',
        // borderBottom: 'none',
        // borderLeft: '2px solid white',
      },
    },
    '&:last-child': {
      // borderTop: '2px solid white',

      '@media(min-width: 700px)': {
        // borderTop: 'none',
        // borderRight: '2px solid white',
      },
    },
  }),
  imageWrapper: css({
    border: '2px solid #7e069a',
    maxHeight: '155px',
    overflow: 'hidden',

    '&:first-child': {
      // borderBottom: '2px solid white',
      marginBottom: '15px',

      '@media(min-width: 700px)': {
        marginBottom: '0px',
        // borderBottom: 'none',
        // borderLeft: '2px solid white',
      },
    },
  }),
  hide: css({
    opacity: 0
  }),
  arrows: css({
    textAlign: 'right',
    display: 'none',

    '@media(min-width: 700px)': {
      display: 'block',
    },
  }),
  arrowsRight: css({
    textAlign: 'left',
  }),
  arrow: css({
    height: '15px',
  }),
  arrowRight: css({
    transform: 'rotate(180deg)',
  }),
  help: css({
    marginTop: '20px',
    fontSize: '14px',
    textAlign: 'center',
    display: 'none',

    '@media(min-width: 700px)': {
      display: 'block',
    }
  }),
}



// WEBPACK FOOTER //
// ./src/components/Question/styles.js